import React, { Component } from "react";
import { connect } from "react-redux";

import messagesService from "../../services/messagesService";
import { updateTypingUsers, addNewMessageToCurrentChannel } from "../../store/messages";

import { Segment, Comment, Message as SemanticMessage } from "semantic-ui-react";

import MessagesHeader from "./MessagesHeader";
import MessagesForm from "./MessagesForm";
import Message from "./Message";
import Typing from "./Typing";
import Skeleton from "../utils/Skeleton";

class Messages extends Component {
    componentDidMount() {
        this.setupListeners();
    }

    componentDidUpdate({ channels: { currentChannel: prevChannel } }) {
        const { channels } = this.props;

        if (!channels.currentChannel) return;

        this.autoScrollDiv.parentElement.scrollTop === 0 && this.autoScrollDiv.scrollIntoView({ behavior: "smooth" });

        prevChannel?.id !== channels.currentChannel.id && this.setupListeners();
    }

    setupListeners() {
        if (!this.props.channels.currentChannel) return;

        this.setupTypingListeners();

        this.setupAddMessageListener();
    }

    setupAddMessageListener() {
        const { channels, addNewMessageToCurrentChannel } = this.props;

        let newMessages = [];

        messagesService.setOnAddMessageListener(channels.currentChannel.id, async snap => {
            const message = { id: snap.key, ...snap.val() };

            if (message?.image) message.image = message.image.split("...")[0];

            if (!newMessages.some(({ id }) => id === message.id)) {
                newMessages = [...newMessages, message];

                addNewMessageToCurrentChannel(newMessages);
            }
        });
    }

    setupTypingListeners() {
        const { channels, currentUser, updateTypingUsers } = this.props;

        let typingUsers = [];

        messagesService.setOnUpdateTypingListener(channels.currentChannel.id, "child_added", snap => {
            if (snap.key !== currentUser?.uid && !typingUsers.some(({ id }) => id === snap.key)) {
                typingUsers = [...typingUsers, { id: snap.key, name: snap.val() }];

                updateTypingUsers(typingUsers);
            }
        });

        messagesService.setOnUpdateTypingListener(channels.currentChannel.id, "child_removed", snap => {
            if (snap.key !== currentUser?.uid) {
                typingUsers = typingUsers.filter(({ id }) => id !== snap.key);

                updateTypingUsers(typingUsers);
            }
        });

        messagesService.typingRef.child(channels.currentChannel.id).child(currentUser.uid).onDisconnect().remove();
    }

    componentWillUnmount() {
        const { channels: { currentChannel } = {}, currentUser } = this.props;

        if (!currentChannel || !currentUser) return;

        messagesService.updateTyping(false, currentChannel.id, { id: currentUser.uid, name: currentUser.displayName });

        messagesService.typingRef.child(currentChannel.id).off();
    }

    renderMessages = (messages, channels, currentUser) => {
        // if (messages.loading) return <Loader active inverted content="Loading" size="big" />;
        if (messages.loading) return Array.from({ length: 10 }, (_, idx) => <Skeleton key={idx} />);
        //
        else if (channels.channels.length && messages.messages.length && messages.searchFiltering)
            return messages.filteredMessages.map(message => (
                <Message key={message.id} {...message} currentUser={currentUser} />
            ));
        //
        else if (channels.channels.length && messages.messages.length && !messages.searchFiltering)
            return messages.messages.map(message => <Message key={message.id} {...message} currentUser={currentUser} />);
        //
        else if (!channels.channels.length)
            return <SemanticMessage size="big">Create a Channel To Start a Dev Chat</SemanticMessage>;
        //
        else return <SemanticMessage size="big">Start a Dev Chat Now!</SemanticMessage>;
    };

    render() {
        const { channels, messages, currentUser } = this.props;

        return (
            <div className="messages-chat">
                <MessagesHeader channels={channels} messages={messages} />

                <Segment className="messages-list">
                    <Comment.Group className="messages">
                        {this.renderMessages(messages, channels, currentUser)}

                        {messages.typingUsers.map(({ id, name }) => (
                            <Typing key={id} username={name} />
                        ))}

                        <div ref={node => (this.autoScrollDiv = node)}></div>
                    </Comment.Group>
                </Segment>

                <MessagesForm
                    currentUser={currentUser}
                    currentChannel={channels.currentChannel}
                    isPrivateChannel={channels.isPrivateChannel}
                />
            </div>
        );
    }
}

export default connect(null, { updateTypingUsers, addNewMessageToCurrentChannel })(Messages);
